import AnchorLink from "react-anchor-link-smooth-scroll"
import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import ButtonSubmit from "../../components/Button"
import Container from "../../components/UI/Container"
import Text from "../../components/Text"
import Wrapper from "./ebookcalltoaction.style"

const EbookCta = () => {
  const Data = useStaticQuery(graphql`
    query {
      alpackedJson {
        EBOOK_CTA {
          title
          button {
            label
            path
          }
          items
        }
      }
    }
  `)

  const { EBOOK_CTA } = Data.alpackedJson

  return (
    <Wrapper>
      <Container width="1280px">
        <div className="left-col">
          <Text content={EBOOK_CTA.title} className="title" />
          <AnchorLink href="#contact" offset="60">
            <ButtonSubmit title={EBOOK_CTA.button.label} className="button" />
          </AnchorLink>
        </div>
        <div className="right-col">
          <ul className="list-items">
            {EBOOK_CTA.items.map((item, index) => {
              return <li key={index}>{item}</li>
            })}
          </ul>
          <AnchorLink href="#contact" offset="60">
            <ButtonSubmit
              title={EBOOK_CTA.button.label}
              className="button-alt"
            />
          </AnchorLink>
        </div>
      </Container>
    </Wrapper>
  )
}

export default EbookCta
